import * as moment from 'moment'
import { LegalEnum } from '../content/enums/LegalEnum'
import { SettingsModel } from './settings.model'

export class AdministrationModel {
  id: number
  name: string
  created_at: moment.Moment | null
  stopped_at: any
  owner: string
  owner_id: number
  owner_origin: string
  is_beta: boolean
  legal_form: string
  settings: SettingsModel

  /**
   * Constructor.
   *
   * @param administration
   */
  constructor(administration) {
    this.id = administration.id
    this.name = administration.name
    this.is_beta = false

    if (administration.owner) {
      this.owner = administration.owner
    }

    if (administration.owner_id) {
      this.owner_id = administration.owner_id
    }

    if (administration.owner_origin) {
      this.owner_origin = administration.owner_origin
    }

    if (administration.is_beta) {
      this.is_beta = administration.is_beta
    }

    if (administration.legal_form) {
      this.legal_form = LegalEnum[administration.legal_form]
    }

    if (administration.stopped_at) {
      this.stopped_at = moment(administration.stopped_at)
    }

    this.created_at = administration.created_at ? moment(administration.created_at) : null
    this.settings = administration.settings ? new SettingsModel(administration.settings) : null
  }

  /**
   * Add the settings to the administration abject.
   *
   * @param settings
   */
  public setSettings(settings: SettingsModel) {
    this.settings = new SettingsModel(settings)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/administration.model.ts